import { Dialog } from '@/components/ui/dialog.tsx'

import type { DialogProps } from '../types'
import { AccountingAdditionalCostTypesTable } from './AccountingAdditionalCostTypesTable.tsx'

interface Props extends DialogProps {}

export const AccountingAdditionalCostTypesDialog = ({
  isOpen,
  onClose,
}: Props) => {
  return (
    <Dialog
      show={isOpen}
      panelClassName="min-w-[800px]"
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Additional Cost Type</Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="min-w">
        <AccountingAdditionalCostTypesTable />
      </Dialog.Description>
    </Dialog>
  )
}
